import { ClientVersion, Document, isNaturalClient, Maybe, MortgageReason, TemplateType } from '@acre/graphql'

export const messagePrefix = 'cases.referClient'

export const caseHasSignedIdd = (documents?: Maybe<Document[]>) => {
  return documents?.some((doc) => {
    const isIddTemplate = doc.template_type === TemplateType.Idd || doc.template_type === TemplateType.ClientPortalIdd

    const isVerified = doc.verification_count && doc.verification_count > 0

    return isIddTemplate && isVerified
  })
}

export const caseEligibleForClientReferral = (
  mortgageReason: Maybe<MortgageReason>,
  clients: ClientVersion[],
  btlThroughCompany?: boolean,
) => {
  const eligibleMortgageReasons = [
    MortgageReason.ReasonFtb,
    MortgageReason.ReasonHouseMove,
    MortgageReason.ReasonRemortgage,
    MortgageReason.ReasonFurtherAdvance,
    MortgageReason.ReasonBtl,
    MortgageReason.ReasonBtlRemortgage,
  ]

  const hasNaturalClients = clients?.some((client) => isNaturalClient(client.details))

  return mortgageReason && eligibleMortgageReasons.includes(mortgageReason) && hasNaturalClients && !btlThroughCompany
}
